import { createContext, useContext } from 'react';

export const RackPricingContext = createContext();

export function useRackPricing() {
  return useContext(RackPricingContext);
}
